<template>
	<div class="py-300 py-500-md bg-color-greige">
		<div class="container">
			<InfoCardSingular :card="infoCard" card-heading-style="heading-1" :use-full-img-url="true" theme="greige" />
		</div>
		<p class="container mt-300-smo mt-500 text-align-center muted eta zeta-smo">
			<BaseLinkButton classes="muted text-decoration-underline" @click="openModal">Learn more</BaseLinkButton>
			about the assumptions in this section, or view our
			<BaseLink :link="performanceDisclosure" classes="muted text-decoration-underline" />.
		</p>
	</div>
</template>
<script setup lang="ts">
import { annualReturnsDisclosureModalProps } from '@constants/annual-returns-data';
import { computed } from 'vue';
import { CurrentModal } from 'types/modal';
import DisclaimerSimple from '@components/disclaimer/disclaimer-simple.vue';
import { InfoCard } from 'types/layout';
import InfoCardSingular from '@components/layout/info-card-singular.vue';
import { performanceDisclosure } from '@constants/links';
import { SanityInfoCard } from 'types/sanity/marketing-components';
import { useAppStore } from '@stores/app';

interface Props {
	data: SanityInfoCard;
}

const props = defineProps<Props>();

const appStore = useAppStore();

const annualReturnsDisclosureModal: CurrentModal = {
	modal: DisclaimerSimple,
	props: annualReturnsDisclosureModalProps
};

const infoCard = computed((): InfoCard => {
	return {
		imageUrl: props.data.image?.asset.url ?? '',
		imageAlt: props.data.image?.asset.altText ?? '',
		heading: props.data.heading ?? '',
		title: props.data.title,
		description: [props.data.description],
		link:
			props.data.link?.linkText && props.data.link?.url
				? {
						text: props.data.link.linkText,
						href: props.data.link.url
					}
				: undefined
	};
});

function openModal(): void {
	appStore.updateCurrentModal(annualReturnsDisclosureModal);
}
</script>
